import React from 'react'
import { Helmet } from 'react-helmet';
import '../css/schedule.css';

export default function Schedule() {
    return (
        <div className="schedule-content">
            <Helmet>
                <title>In Motion Dance | Schedule</title>
            </Helmet>
            <h1>Fall/Spring Schedule<br/>(Sept 2, 2025 -June 20, 2026)</h1>
            <h2>Updated: Thursday, June 25, 2026</h2>
            <h2><strong>Fitness classes are in</strong> BOLD</h2>
            <div className="schedule-gridWrapper">

                {/* Monday */}
                <div className="schedule-mondayColumn">
                <h2>Monday</h2>
                    <table>
                        <tr>
                            <th>Room 1</th>
                            <th>Room 2</th>
                        </tr>
                        
                        <tr>
                            <td></td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>BTT + Ballet Tap Tumbling & other Styles<br/>(AGES 3-5)<br/>10:00-11:00<br/><strong>(FULL)</strong></td>
                            <td></td>
                        </tr>
                        <tr>
                            <td></td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>Preschool<br/>(AGES 4-5)<br/>12:00-2:00<br/></td>
                            <td></td>
                        </tr><tr>
                            <td>Pre K Dance<br/>2:00-2:30<br/></td>
                            <td></td>
                        </tr>
                            <td></td>
                            <td></td>
                        <tr>
                            <td>Pointe<br/>3:45-4:45<br/>2 Classes Req</td>
                            <td>Emerge Dance Company (Tryout Req)<br/>4:00-4:50<br/></td>
                        </tr>
                        <tr>
                            <td>BTT - Ballet Tap Tumbling<br/>(AGES 3-5)<strong>(FULL)</strong><br/>4:45-5:30 (Starts in RM 2)<br/></td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>INT BTT<br/>(AGES 5-7)<br/>5:30-6:15<br/>(Move to RM 2)</td>
                            <td>Tap 2<br/>(AGES 8+ & Skill Level)<br/>5:15-6:00</td>
                        </tr>
                        <tr>
                            <td>Ballet 5/6<br/>(Pre Pointe)<br/>6:00-7:00<br/></td>
                            <td></td>
                           </tr>                        
                        <tr>
                            <td>Excel Company Class 1<br/>7:00-8:30<br/></td>
                            <td>Tumbling 2<br/>(AGES 6+)<br/>6:15-7:15<br/></td>
                        </tr>
                        <tr>
                            <td></td>
                            <td>Adult/Teen Tap<br/>(Intermediate + Skill Level)<br/>7:30-8:30</td>
                        </tr>
                       
                        
                    </table>
                </div>
                {/* Tuesday */}
                <div className="schedule-tuesdayColumn">
                <h2>Tuesday</h2>
                    <table>
                        <tr>
                            <th>Room 1</th>
                            <th>Room 2</th>
                        </tr>
                        <tr>
                            <td>Preschool<br/>(AGES 3-4)<br/>9:30-11:30<br/></td>
                            <td><br/><br/><br/><br/></td>
                        </tr>
                        <tr>
                            <td>Pre K Dance<br/>11:30-12:00<br/></td>
                            <td><br/><br/><br/><br/><br/></td>
                        </tr>
                            <td></td>
                            <td></td>
                        <tr>
                            <td>Preschool<br/>(AGES 3-4)<br/>12:30-2:30<br/></td>
                            <td></td>
                        </tr><tr>
                            <td>Pre K Dance<br/>2:30-3:00<br/></td>
                            <td></td>
                        </tr>
                            <td></td>
                            <td></td>
                        <tr>
                            <td>Jazz 2/3<br/>(AGES 8-11)<br/>4:00-5:00</td>
                            <td>BTT - Ballet Tap Tumbling<br/>(AGES 3-5)<br/>3:30-4:15</td>
                        </tr>
                        <tr>
                            <td>Balllet 2<br/>(AGES 8-11)<br/>5:00-6:00</td>
                            <td>Tumbling 1<br/>(AGES 18mo-5)<br/>4:15-5:15<br/></td>
                        </tr>
                        <tr>
                            <td>Adult Ballet<br/>6:00-7:00</td>
                            <td>Tumbling 3<br/>(Skill Level)<br/>5:15-6:45<br/></td>
                        </tr>
                        <tr>
                            <td>Adult Hip Hop<br/>7:00-7:45</td>
                            <td>Cheer<br/>(AGES 5-9)<br/>6:45-7:30</td>
                        </tr>
                        <tr>
                            <td><strong>Zumba<br/>7:45-8:45</strong></td>
                        </tr>
                        
                        </table>
                </div>
                {/* Wednesday */}
                <div className="schedule-wednesdayColumn">
                <h2>Wednesday</h2>
                    <table>
                        <tr>
                            <th>Room 1</th>
                            <th>Room 2</th>
                        </tr>
                        <tr>
                            <td>Mini-Combo Dance/Tumbling<br/>(AGES 18mos-3yr)<br/>9:45-10:15<br/></td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>Balllet Jazz Tumbling (BJT)<br/>(AGES 3-5)<br/>10:15-11:00<br/></td>
                            <td><br/><br/><br/><br/><br/></td>
                        </tr>
                        <tr>
                            <td></td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>Preschool<br/>(AGES 4-5)<br/>12:00-2:00<br/></td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>Pre K Dance<br/>2:00-2:30<br/></td>
                            <td></td>
                        </tr>
                            <td></td>
                            <td></td>
                        <tr>
                            <td>Excel Company Class 2<br/>3:30-5:00</td>
                            <td>Ballet 1A<br/>(AGES 5-7)<br/>4:15-5:00</td>
                        </tr>
                        <tr>
                            <td>Pointe<br/>5:00-6:00<br/>(2 classes REQ)</td>
                            <td>Eclipse Dance Company<br/>5:00-6:00</td>
                        </tr>
                        <tr>
                            <td>Tap 3<br/>(Skill Level)<br/>6:00-7:00</td>
                            <td>Hip Hop 2/3<br/>(AGES 8-11)<br/>6:00-7:00</td>
                        </tr>
                        <tr>
                            <td>Hip Hop 4/5<br/>(AGES 12+ & Skill Level)<br/>7:00-8:00</td>
                            <td>Beginning Adult Tap<br/>7:00-8:00</td>
                        </tr>
                        <tr>
                            <td></td>
                            <td></td>
                        </tr>
                    </table>
                </div>
                {/* Thursday */}
                <div className="schedule-thursdayColumn">
                <h2>Thursday</h2>
                    <table>
                        <tr>
                            <th>Room 1</th>
                            <th>Room 2</th>
                        </tr>
                        <tr>
                            <td>Preschool<br/>(AGES 3-4)<br/>9:30-11:30<br/></td>
                            <td>BTT - Ballet Tap Tumbling<br/>(AGES 3-5)<br/>10:00-10:45</td>
                        </tr>
                            <td>Pre K Dance<br/>11:30-12:00<br/></td>
                            <td></td>
                        <tr>
                            <td></td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>Preschool<br/>(AGES 3-4)<br/>12:30-2:30<br/></td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>Pre K Dance<br/>2:30-3:00<br/></td>
                            <td></td>
                        </tr>
                            <td></td>
                            <td></td>
                        <tr>
                            <td>Pointe<br/>3:30-5:00<br/>(2 classes REQ)</td>
                            <td>Ballet 1B<br/>(AGES 5-7)<br/>4:15-5:00</td>
                        </tr>
                        <tr>
                            <td>Ballet 5/6<br/>(Skill Level)<br/>5:00-6:00</td>
                            <td>Jazz 1 / Hip Hop 1 Combo<br/>(AGES 5-7)<br/>5:00-6:00<br/></td>
                        </tr>
                        <tr>
                            <td>Jazz 4/5<br/>(AGES 12+ & Skill Level)<br/>6:15-7:15</td>
                            <td>Contemporary Lyrical 2/3<br/>(AGES 8+)<br/>6:00-7:00</td>
                        </tr>
                        <tr>
                            <td>Ballet 3/4<br/>(AGES 10+ or Skill Level)<br/>7:15-8:15</td>
                            <td><strong>StepIt<br/>7:30-8:30</strong></td>
                        </tr>
                        
                    </table>
                </div>
                {/* Friday */}
                <div className="schedule-fridayColumn">
                <h2>Friday</h2>
                    <table>
                        <tr>
                            <th>Room 1</th>
                            <th>Room 2</th>
                        </tr>
                        <tr>
                            <td><br/><br/><br/></td>
                            <td><br/><br/><br/></td>
                        </tr>
                        <tr>
                            <td><br/><br/></td>
                            <td><br/><br/></td>
                        </tr>
                        <tr>
                            <td></td>
                        </tr>
                        <tr>
                            <td>Preschool<br/>(AGES 4-5)<br/>12:00-2:00<br/></td>
                            <td><br/><br/><br/></td>
                        </tr>
                            <td>Pre K Dance<br/>2:00-2:30<br/></td>
                            <td><br/><br/></td>
                        <tr>
                            <td></td>
                            <td></td>
                        </tr>
                        
                        <tr>
                            <td>Eclipse Dance Company<br/>4:00-5:30</td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>Advanced Contemporary (Approval Req)<br/>5:30-6:30<br/></td>
                            <td></td>
                        </tr>
                    </table>
                </div>
                {/* Saturday */}
                <div className="schedule-saturdayColumn">
                <h2>Saturday</h2>
                    <table>
                        <tr>
                            <th>Room 1</th>
                        </tr>
                        <tr>
                            <td><strong>StepIt<br/>8:00-9:00</strong><br/></td>
                        </tr>
                        <tr>
                            <td>Break 1/2 & 3<br/>(AGES 6+)<br/>9:00-10:00</td>
                        </tr>
                        <tr>
                            <td>Company Rehersals<br/>10:00-12:00</td>
                        </tr>
                    </table>
            </div>
            </div>                        
        </div>
    )
}